import React from 'react';

import { DateTime } from 'luxon';
import { formatRelativeDateTime } from 'utils/dateUtils';

export type BidStatus = 'Initial' | 'Rejected' | 'Accepted';

export type BidEntry = {
  type: 'COUNTER BID' | 'ORIGINAL BID';
  carveName: string;
  pricePercent: number;
  status: BidStatus;
  timestamp: string; // ISO format
};

const statusStyles: Record<BidStatus, string> = {
  Rejected: 'bg-red-400 text-white',
  Initial: 'bg-blue-200 text-black',
  Accepted: 'bg-green-500 text-white',
};

const BidHistory = ({ bids }: { bids: BidEntry[] }) => {
  return (
    <div className="w-full max-w-[1200px] px-4 text-white">
      <h2 className="mb-3 text-left text-lg text-slate-200">Bidding history</h2>
      <ul className="space-y-3">
        {bids.map((bid, index) => {
          const display = formatRelativeDateTime(bid.timestamp);
          return (
            <li
              key={index}
              className="grid cursor-pointer grid-cols-[500px_250px_100px_1fr] items-center justify-between border-l border-gray-800 py-2 pl-3 hover:bg-brand-950"
            >
              <div className="flex items-center gap-2">
                <span className="text-l uppercase tracking-wide">{bid.type}: </span>
                <span className="text-gray-400">{bid.carveName}</span>
              </div>

              <div className="flex gap-2">
                <span className="text-l tracking-tight">Price</span>
                <span className="text-l text-gray-400">{bid.pricePercent.toFixed(2)}%</span>
              </div>

              <div>
                <span
                  className={`rounded px-2 py-1 text-xs font-semibold ${statusStyles[bid.status]}`}
                >
                  {bid.status}
                </span>
              </div>
              <div className="flex items-center justify-end">
                <span className="min-w-[240px] text-sm text-gray-400">{display}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BidHistory;
